import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/styles/global.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(

<App/>

);



{/* <React.StrictMode>  
    <App/>
</React.StrictMode> */}